import keyMirror from 'keymirror';

module.exports = keyMirror({
  CLOSE_MODAL: null,
  OPEN_MODAL: null,
  NAVIGATE_URL: null,
});
